import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

declare var $: any;

@Component({
    selector: 'ups-dashboard-accordeon',
    template: require('./ups-dashboard-accordeon.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class UpsDashboardAccordeonComponent implements OnInit {
    
    public ham: boolean = false;

    ngOnInit() {

    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }

    searchInformation() {
        // Call API for search Information
    }

}


